import { useDispatch } from "react-redux"
import StarRatings from "react-star-ratings"
import styled from "styled-components"
import { getDetailPlace, getYellowPagesImages, setSelectedIsletmeItem } from "../../features/yellowPages/yellowPagesSlice"


const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px;
    padding-right: 0 !important;
    gap: 5px;
    border-bottom: 1px solid ${({theme}) => theme.mainBorderColor};
    cursor: pointer;

    &:Hover{
      background-color: ${({theme}) => theme.secondaryBgColor};
    }

    .isletme-name{
      font-size: var(--font-size-md);
      font-weight: var(--font-weight-lg);
    }

    .isletme-rating{
    display: flex;
    align-items: center;
    gap: 5px;
    font-weight: var(--font-weight-lg);
    font-size: var(--font-size-sm);
    }

    .isletme-data{
    font-weight: var(--font-weight-md);
    font-size: var(--font-size-sm);
    }

    .isletme-opening-data{
    display: flex;
    align-items: center;
    gap: 10px;
    
    .isletme-is-open-green{
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
        color: var(--color-green);
    }
    
    .isletme-is-open-red{
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
        color: var(--color-red);
    }

    .date-time{
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        color: ${({theme}) => theme.secondaryTextColor};
    }

    }
`

const IsletmeItem = ({item, setActivePoint}) => {

  const dispatch = useDispatch()

  const handleClick = () => {
  // dispatch(getYellowPagesImages(item))
  dispatch(getDetailPlace())
  }


  return (
    <Container onMouseEnter={() => setActivePoint({lat: item.location.latitude, lng:item.location.longitude} )} onMouseLeave={() => setActivePoint(null)} onClick={handleClick}>
    <h3 className="isletme-name">{item?.displayName?.text}</h3>
    <div className="isletme-rating">
      {
        (item?.userRatingCount && item?.userRatingCount > 0) ? 
        <div style={{display: "flex", alignItems: "center", gap: "5px"}}>
          {item?.rating}
          <StarRatings rating={item?.rating} starRatedColor="#EBB00E" starEmptyColor="#aaa3a3" starDimension="15px" starSpacing="2px"/>({item?.userRatingCount})
        </div>
        : 
        <div>Yorum Yok</div>
      }
    </div>
    <div className="isletme-data">{item?.primaryTypeDisplayName?.text}</div>
    <div className="isletme-data">{item?.formattedAddress}</div>
    <div className="isletme-opening-data">
      <div className={item?.currentOpeningHours?.openNow === true ? "isletme-is-open-green" : item?.currentOpeningHours?.openNow === false && "isletme-is-open-red"}>{item?.currentOpeningHours?.openNow === true ? "Açık" : item?.currentOpeningHours?.openNow === false && "Kapalı"} </div>
      <div className="date-time">{item?.currentOpeningHours?.weekdayDescription?.length > 0 && item?.currentOpeningHours?.weekdayDescriptions[new Date()?.getDay()-1]}</div>
    </div>
  </Container>
  )
}

export default IsletmeItem